import mapSendingControl from './get-sending-control'

export default (data) => ({
  approvedDomains: data.approvedDomains.map(mapSendingControl),
  emails: data.emails.map(mapSendingControl),
})
